import { HourCodeService, IHourCode } from "../../../services/hourCode.service";

class HourCodesItemController implements ng.IComponentController {
    private hourCode: IHourCode;

    constructor(private HourCodeService: HourCodeService,
                private $state: ng.ui.IStateService,
                private SweetAlert: any) {
        'ngInject';
    }

    deleteHourCode() {
        this.SweetAlert.swal({
            title: 'Weet je het zeker?',
            text: "Je kunt dit niet ongedaan maken!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja, verwijderen!',
            cancelButtonText: 'Nee, annuleren!',
        }, (isConfirm) => {
            if (isConfirm) {
                this.HourCodeService.delete(this.hourCode.id).then(() => {
                    this.$state.go('^', {reload: true});
                });
            }
        });
    }
}

export const hourCodesItemComponent: ng.IComponentOptions = {
    controller: HourCodesItemController,
    bindings: { 
        hourCode: '<'
    },
    template: require('./hourCodes.item.html')
}




// WEBPACK FOOTER //
// ./src/app/modules/settings/hourCodes/hourCodes.item.component.ts